import React from 'react'
import { Moment } from 'moment-timezone'
import { DateOrTimeView } from '@mui/x-date-pickers'
import TenantDateTimePicker from '../../TenantDateTimePicker'
import { RangeValue } from '../types'

interface DateTimeRangeFilterProps {
  label: string
  value: RangeValue
  onChange: (value: RangeValue) => void
}

const slotProps = { textField: { size: 'small' as const, fullWidth: true } }
const views: DateOrTimeView[] = ['year', 'month', 'day', 'hours', 'minutes']

const DateTimeRangeFilter: React.FC<DateTimeRangeFilterProps> = ({ label, value, onChange }) => {
  return (
    <div>
      <label className="form-label">{label}</label>
      <div className="d-flex gap-2 align-items-center">
        <TenantDateTimePicker
          value={value.from}
          maxDateTime={value.to ?? undefined}
          views={views}
          slotProps={slotProps}
          onChange={(from: Moment | null) => onChange({ ...value, from })}
        />
        <span className="table-filters__range-separator">-</span>
        <TenantDateTimePicker
          value={value.to}
          minDateTime={value.from ?? undefined}
          views={views}
          slotProps={slotProps}
          onChange={(to: Moment | null) => onChange({ ...value, to })}
        />
      </div>
    </div>
  )
}

export default DateTimeRangeFilter
